import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

interface Properties {
    loading: boolean,
    text?: string,
}

export default function LoadingIndicator(properties: Properties) {
    const { t } = useTranslation();

    return <div className="flex flex-1 items-center justify-center gap-2 p-4" role="status">
        {properties.loading
            ?
            <>
                <Loader2 aria-hidden="true" className="h-4 w-4 animate-spin text-muted-foreground" />
                <span className="text-sm text-muted-foreground">{`${t('global.loading')} ...`}</span>
            </>
            :
            <div className="text-sm">{properties.text}</div>
        }
    </div>;
}
